:host {
  display: block;
}

.c-card-content {
  padding: 0 var(--_c-card-gap, 24px);
  display: flex;
  flex-direction: column;
  gap: var(--_c-card-gap);

  ::slotted(*) {
    max-width: 100%;
  }
}
